import { CustomQuery } from '../types';
import { BaseProps } from '@vsf-enterprise/sapcc-api';

export const createBasePropsFromCustomQuery = (
  customQuery?: CustomQuery
): BaseProps =>
  customQuery
    ? {
        fields: customQuery?.fields,
        lang: customQuery?.lang,
        currency: customQuery?.currency
      }
    : {};
